// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9822) return "static/chunks/9822-f0d7cb157a7b3430.js";
	if (chunkId === 7927) return "static/chunks/7927-87ec4d0ed0e38d95.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5341":"da02ab921c346655","9651":"9be695e992890e60"}[chunkId] + ".js";
};